export interface App {
  appId: 613238 | 677975 | 1781;
  region: 'sg' | 'cn';

  monitor: {
    slardarBizId: string;
    slardarCDN: string;
    teaCDN: string;
  };

  source: {
    favicon: string;
    ogImage: string;
    ogType: 'summary' | 'summary_large_image';
  };
}

export const appConfig: App = {
  appId: 613238,
  region: 'sg',

  monitor: {
    slardarBizId: 'oasis_activity_pst_i18n',
    slardarCDN: 'https://sf16-short-sg.bytedapm.com/slardar/fe/sdk-web/browser.sg.js',
    teaCDN: 'https://lf-global-static.iapplogcdn.com/obj/applog-sdk-static-sg/log-sdk/collect/5/collect.js',
  },

  source: {
    favicon:
      'https://lf16-pstcdn-alisg.bytedgame.com/obj/lf-game-alisg/gdl_app_613238/web/public/favicon.png',
    ogType: 'summary',
    ogImage:
      'https://lf16-pstcdn-alisg.bytedgame.com/obj/lf-game-alisg/gdl_app_613238/web/public/favicon.png',
  },
};

export const cnAppConfig: App = {
  appId: 677975,
  // appId: 1781,
  region: 'cn',

  monitor: {
    slardarBizId: 'oasis_activity_pst_cn',
    slardarCDN: 'https://lf3-short.ibytedapm.com/slardar/fe/sdk-web/browser.cn.js',
    teaCDN: 'https://lf3-cdn-tos.bytescm.com/obj/static/log-sdk/collect/5.1/collect.js',
  },
  source: {
    favicon: 'https://lf3-pst-cn.dailygn.com/obj/lf-game-lf/gdl_app_677975/web/public/favicon.png',
    ogType: 'summary',
    ogImage: 'https://lf3-pst-cn.dailygn.com/obj/lf-game-lf/gdl_app_677975/web/public/favicon.png',
  },
};
